import { useLocation } from '@okapi/router-react';

export const isCheckout = (path: string): boolean => path.replace(/\//g, '') === 'checkout';

export const useIsCheckout = (): boolean => {
  const [location] = useLocation();
  return isCheckout(location);
};
